import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import ColorScale from '_class/ColorScale';
import React, { Component } from 'react';
import '../../Verdict.scss';

var VerdictDisplayLevel = /*#__PURE__*/function (_Component) {
  _inherits(VerdictDisplayLevel, _Component);

  var _super = _createSuper(VerdictDisplayLevel);

  function VerdictDisplayLevel() {
    _classCallCheck(this, VerdictDisplayLevel);

    return _super.apply(this, arguments);
  }

  _createClass(VerdictDisplayLevel, [{
    key: "render",
    value: function render() {
      var _this = this;

      if (this.props.scale == null) {
        return null;
      }

      var verdictIndexColors = new ColorScale(this.props.scale.levels.length).get();
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-level-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "verdict-cells"
      }, this.props.scale.levels.map(function (cell) {
        var styles = {};

        if (_this.props.verdict != null) {
          if (cell.id == _this.props.verdict.scaleLevelId) {
            styles = {
              backgroundColor: cell.colorCode != null ? cell.colorCode : verdictIndexColors[cell.level],
              color: 'white'
            };
          }
        }

        return /*#__PURE__*/React.createElement("div", {
          key: 'verdict-cell-display-' + cell.id,
          style: styles,
          className: "cell"
        }, cell.localizationText != null ? cell.localizationText : cell.level);
      })));
    }
  }]);

  return VerdictDisplayLevel;
}(Component);

export default VerdictDisplayLevel;